import { Component, OnInit } from '@angular/core';
import { User } from '../user';
import { UserRegistrationService } from '../user-registration.service';

export interface Plan {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})

export class SignupComponent implements OnInit {

  flag1=0;
  flag2=0;
  user: User = new User("","",0,"","","");
  message: any;

  constructor(private service: UserRegistrationService) { }

  ngOnInit() {
  }
  public registerProcess(){
  let response = this.service.doRegistration(this.user);
  response.subscribe((data) => this.message = (data));
  this.flag1=1;
  this.flag2=1;
  
  }
  plans: Plan[] = [
    {value: 'Beginner', viewValue: 'Beginner'},
    {value: 'Intermediate', viewValue: 'Intermediate'},
    {value: 'Advanced', viewValue: 'Advanced'}
  ];
}
